export default {
  女装: "කාන්තා ඇඳුම්",
  男装: "පිරිමි",
  手机和小工具: "ජංගම දුරකථන සහ කුඩා මෙවලම්",
  居家生活: "නිවාස ජීවිතය",
  电脑及周边设备: "පරිගණක හා පර්යන්ත උපකරණ",
  美容及个人护理: "අලංකාරය සහ පෞද්ගලික රැකවරණය",
  家用电器: "උපකරණය",
  健康与保健: "සෞඛ්ය හා සෞඛ්ය සේවා",
  食品和饮料: "ආහාර සහ බීම",
  玩具_儿童和婴儿: "සෙල්ලම් බඩු, ළමයින් සහ ළදරුවන්",
  童装时尚: "ළමා ඇඳුම් විලාසිතා",
  视频游戏: "වීඩියෝ ක්රීඩා",
  运动与户外: "ව්යායාම සහ එළිමහන්",
  爱好与书籍: "විනෝදාංශ සහ පොත්",
  相机和无人机: "කැමරාව සහ ඩ්රෝන යානා",
  宠物食品及用品: "සුරතල් ආහාර සහ සැපයුම්",
  女士包袋: "කාන්තා බෑගය",
  男士包袋: "පිරිමි බෑගය",
  珠宝及配饰: "ස්වර්ණාභරණ සහ උපාංග",
  手表: "නරඹන්න",
  女鞋: "කාන්තා සපත්තු",
  男装鞋: "පිරිමි සපත්තු",
  汽车: "කාර්",
  我附近的ShopeePay: "මගේ අසල ඇති ෂෝපේප්",
  餐饮_旅行和服务: "ආහාරපාන, ගමන් සහ සේවය",
  旅行及行李: "සංචාරක හා ගමන් මලු",
  各种各样的: "විවිධ",
  我是来买什么的: "මම ආවේ මිලදී ගැනීමට",
  对不起_找不到_相关的商品: "කණගාටුයි, ඔබට අදාළ නිෂ්පාදන සොයාගත නොහැක",
  类别: "වර්ගය",
  产品: "නිෂ්පාදන",
  店铺: "සාප්පුව",
  首页: "මුල් පිටුව",
  限时秒杀: "සීමිත කාලය ස්පයික්",
  博客: "බ්ලොග් අඩවිය",
  所有品牌: "සියලුම වෙළඳ නාම",
  所有类别: "සියලුම කාණ්ඩ",
  我的购物车: "මගේ සාප්පු කරත්තය",
  发货信息: "බෙදා හැරීමේ තොරතුරු",
  交货信息: "බෙදා හැරීමේ තොරතුරු",
  付款: "ගෙවීම",
  确认: "තහවුරු කරන්න",
  您的购物车是空的: "ඔබේ සාප්පු කරත්තය හිස් ය",
  价格: "මිල",
  税: "බදු",
  数量: "ප්රමාණය",
  总计: "එකතුව",
  移除: "ඉවත් කරන්න",
  返回商店: "ගබඩාවට ආපසු යන්න",
  继续发货: "දිගටම භාරදීම දිගටම කරගෙන යන්න",
  筛选: "පෙරණය",
  价格范围: "මිල",
  排序方式: "අනුව තෝරන්න",
  最新: "යාවත්කාලීනව",
  最旧: "පැරණි",
  价格从低到高: "අඩු සිට ඉහළ සිට මිල",
  价格从高到低: "ඉහළ සිට පහළට මිල",
  选择交货类型: "බෙදා හැරීමේ වර්ගය තෝරන්න",
  送货上门: "භාරදීම",
  继续付款: "දිගටම ගෙවන්න",
  任何其他信息: "වෙනත් තොරතුරු",
  或者: "හෝ",
  您的钱包余额: "ඔබේ මුදල් පසුම්බිය ශේෂය",
  余额不足: "ප්රමාණවත් ශේෂයක් ප්රමාණවත් නොවේ",
  支付: "ගෙවන්න",
  我同意: "මම එකඟයි",
  条款和条件: "නියම සහ කොන්දේසි",
  退货政策: "ආපසු දෙන ප්රතිපත්තිය",
  隐私政策: "පෞද්ගලිකත්වය",
  概括: "සාරාංශය",
  项目: "ව්යාපෘතිය",
  全部的: "සියල්ල",
  小计: "ස්කෙච්",
  总运费: "මුළු භාණ්ඩ ප්රවාහනය",
  有优惠码吗_在这里输入: "වට්ටම් කේතයක් තිබේද? මෙතැනට ඇතුළු වන්න",
  申请: "අයදුම් කරන්න",
  编辑: "සංස්කරණය කරන්න",
  删除: "මකන්න",
  添加新地址: "නව ලිපිනයක් එක් කරන්න",
  继续交货信息: "බෙදා හැරීමේ තොරතුරු දිගටම කරගෙන යන්න",
  选择一个地址: "ලිපිනයක් තෝරන්න",
  购买历史: "ඉතිහාසය මිලදී ගන්න",
  下载: "බාගන්න",
  已发送退款请求: "මුදල් ආපසු ගෙවීමේ ඉල්ලීම මඟින් මුදල් ආපසු ගෙවීමක් යවයි",
  对比: "වෙනස",
  对话: "සංවාදය",
  我的钱包: "මගේ මුදල් පසුම්බිය",
  工单: "වැඩ ඇණවුම",
  管理个人资料: "පුද්ගලික තොරතුරු කළමනාකරණය කරන්න",
  登出: "වරන්න",
  重置对比列表: "සංසන්දනාත්මක ලැයිස්තුව නැවත සකසන්න",
  您的对比列表为空: "ඔබේ සංසන්දනාත්මක ලැයිස්තුව හිස් ය",
  在您的购物车中: "ඔබේ සාප්පු කරත්තයේ",
  在您的愿望清单中: "ඔබේ පැතුම් ලැයිස්තුවේ",
  在您的预定列表中: "ඔබගේ නියමිත ලැයිස්තුවේ",
  下载您的产品: "ඔබේ නිෂ්පාදනය බාගන්න",
  选项: "විකල්පය",
  什么都没找到: "මට කිසිවක් හමු නොවීය",
  特色产品: "විශේෂ නිෂ්පාදන",
  最畅销: "හොඳම --සම්පෑම",
  前_名: "පෙර {0} නම",
  查看更多: "තවත් බලන්න",
  查看所有类别: "සියලුම කාණ්ඩ බලන්න",
  十大品牌: "හොඳම වෙළඳ නාම දහය",
  查看所有品牌: "සියලුම වෙළඳ නාම බලන්න",
  登录: "ඇතුල් වන්න",
  手机号码: "දුරකථන අංකය",
  密码: "මුරපදය",
  密码长度为6到16个字符: "මුරපදයේ දිග අක්ෂර 6 සිට 16 දක්වා වේ",
  验证码: "සත්යාපන කේතය",
  登录中: "ඇතුල් වන්න",
  游客登录: "සංචාරක පිවිසුම",
  注册您的商店: "ඔබේ ගබඩාව ලියාපදිංචි කරන්න",
  现在申请: "දැන්ම අයදුම් කරන්න",
  成为商家: "වෙළෙන්දා වන්න",
  现在注册: "දැන්ම ලියාපදිංචි වන්න",
  登录成功: "සාර්ථක පිවිසුම",
  通知: "දැනුම් දෙන්න",
  未找到通知: "දැනුම්දීමක් නැත",
  评论: "අදහස් දැක්වීම",
  估计运输时间: "ඇස්තමේන්තුගත ප්රවාහන කාලය",
  天: "අහස",
  所售: "විකිණීම",
  给商家留言: "වෙළෙන්දාට පණිවිඩයක් තබන්න",
  规格: "පිරිවිතර",
  库存: "ගබඩාවේ ඇත",
  总价: "සාමාන්ය මිල",
  添加到购物车: "ගැලට එක් කරන්න",
  立即购买: "එය දැන් මිලදී ගන්න",
  缺货: "තොග නැති",
  添加到愿望清单: "පැතුම් ලැයිස්තුවට එක් කරන්න",
  加入对比列表: "සංසන්දනාත්මක ලැයිස්තුව එක් කරන්න",
  退款: "මුදල් ආපසු ගෙවීම",
  查看条款: "වගන්තිය බලන්න",
  分享: "බෙදාගන්න",
  描述: "විස්තර කරන්න",
  相关产品: "අදාළ නිෂ්පාදන",
  没有人问过商家: "කිසිවෙකු වෙළෙන්දාගෙන් ඉල්ලා නැත",
  该产品暂无评论: "මෙම නිෂ්පාදනය පිළිබඳ අදහස් දැක්වීමක් නොමැත",
  客户评论: "පාරිභෝගික ප්රකාශය",
  访问商店: "ගබඩාවට පිවිසෙන්න",
  畅销产品: "හොඳම නිෂ්පාදන නිෂ්පාදන",
  日期: "දිනය",
  订单编号: "ඇණවුම් අංකය",
  总额: "සම්පූර්ණ ගෙවීම",
  状态: "රාජ්ය",
  愿望清单: "පැතුම් ලැයිස්තුව",
  还没有添加任何东西: "තවම කිසිවක් එකතු කර නැත",
  注册: "ලියාපදිංචි වන්න",
  邀请码: "ආරාධනා කේතය",
  请输入邀请码: "කරුණාකර ආරාධනා කේතය ඇතුළත් කරන්න",
  用户名: "පරිශීලක නාමය",
  请输入用户名: "කරුණාකර පරිශීලක නාමය ඇතුළත් කරන්න",
  用户名长度为6_14个字符: "පරිශීලක නාමයේ දිග අක්ෂර 6-14 කි",
  昵称: "නික් නම",
  请输入手机号码: "කරුණාකර ජංගම දුරකථන අංකය ඇතුළත් කරන්න",
  手机号码格式错误: "ජංගම දුරකථන අංක ආකෘති දෝෂයකි",
  密码长度为6_16个字符: "මුරපදයේ දිග අක්ෂර 6-16 කි",
  确认密码: "මුරපදය තහවුරු කරන්න",
  请输入确认密码: "කරුණාකර තහවුරු කිරීමේ මුරපදය ඇතුළත් කරන්න",
  提款密码: "මුරපදය ඉවත් කර ගැනීම",
  请输入提款密码: "මුදල් ආපසු ගැනීමේ මුරපදය ඇතුළත් කරන්න",
  提款密码长度为4_16个字符: "ඉවත් වීමේ මුරපදය හි දිග අක්ෂර 4-16 කි",
  请输入验证码: "කරුණාකර සත්යාපන කේතය ඇතුළත් කරන්න",
  在_s后发送: "{0} s ට පසුව යවන්න",
  发送验证码: "සත්යාපන කේතය යවන්න",
  注册即表示您同意我们的条款和条件:
    "ලියාපදිංචිය යනු ඔබ අපගේ නියමයන් හා කොන්දේසි සමඟ එකඟ වන බවයි.",
  创建账号: "ගිණුමක් තනන්න",
  验证码发送成功: "සත්යාපන කේතය සාර්ථකව යවයි",
  确认密码不一致: "මුරපදය නොගැලපෙන බව තහවුරු කරන්න",
  提款密码必须为数字: "මුදල් ආපසු ගැනීමේ මුරපදය අංකනය කළ යුතුය",
  注册成功: "සාර්ථකව ලියාපදිංචි වන්න",
  购物车: "සාප්පු ට්රොලිය",
  账户: "ගිණුම",
  我的账户: "මගේ ගිණුම",
  已经有一个账户: "දැනටමත් ගිණුමක් ඇත",
  新地址: "නව ලිපිනය",
  编辑地址: "සංස්කාරක ලිපිනය",
  保存: "සුරකින්න",
  是否默认: "පෙරනිමිය වේවා",
  具体地址: "විශේෂිත ලිපිනය",
  请输入具体地址: "කරුණාකර නිශ්චිත ලිපිනය ඇතුළත් කරන්න",
  地区: "ප්රදේශය",
  请输入地区: "කරුණාකර ප්රදේශයට ඇතුළු වන්න",
  城市: "නගරය",
  请输入城市: "කරුණාකර නගරය ඇතුලත් කරන්න",
  省份: "පළාත",
  请输入省份: "කරුණාකර පළාතට ඇතුළු වන්න",
  邮政编码: "තැපැල් කේතය",
  请输入邮政编码: "කරුණාකර තැපැල් කේතය ඇතුළත් කරන්න",
  电话号码: "දුරකථන අංකය",
  请输入电话号码: "කරුණාකර දුරකථන අංකය ඇතුළත් කරන්න",
  收货人: "තොගකරු",
  请输入收货人: "කරුණාකර තොගකරු ඇතුළු කරන්න",
  保存成功: "සාර්ථක වන්න",
  最畅销的商家: "හොඳම -සල් වෙළෙන්දා",
  查看所有的商家: "සියලුම වෙළෙන්දන් පරීක්ෂා කරන්න",
  支持政策: "ආධාරක ප්රතිපත්තිය",
  您的电子邮件地址: "ඔයාගේ ඊතැපැල් ලිපිනය",
  订阅: "දායකත්වය",
  联系方式: "සබඳතා තොරතුරු",
  地址: "ලිපිනය",
  美国伊利诺伊州霍夫曼庄园: "ඇමරිකා එක්සත් ජනපදයේ ඩාර්යක්ෂම මනෝ",
  快速链接: "වේගවත් සබැඳිය",
  商家政策: "වෙළඳ ප්රතිපත්තිය",
  submit: "ඉදිරිපත් කරන්න",
  提款银行卡: "ADBB කාඩ්පත",
  我的面板: "මගේ මණ්ඩලය",
  提示: "ඉඟිය",
  确定登出吗: "ඔබට විශ්වාසද ඔබ පිවිසෙන්නේ?",
  确定: "ෂුවර්",
  取消: "අවලංගු කරන්න",
  项目添加到您的购物车: "ව්යාපෘතිය ඔබේ සාප්පු කරත්තයට එකතු කර ඇත",
  经常一起购买: "නිතර මිලදී ගන්න",
  返回购物: "නැවත සාප්පු සවාරි",
  进行结算: "පරීක්ෂා කිරීම වෙත යන්න",
  帮助热线: "ඇමතුම් අංක",
  查看所有通知: "සියලුම දැනුම්දීම් පරීක්ෂා කරන්න",
  请输入密码: "කරුණාකර මුරපදය ඇතුළත් කරන්න",
  前往充值: "නැවත ආරෝපණය කිරීමට යන්න",
  购物车物品: "සාප්පු ට්රොලිය",
  查看购物车: "සාප්පු කරත්තය පරීක්ෂා කරන්න",
  钱包余额: "පසුම්බිය ශේෂය",
  充值钱包: "නැවත ආරෝපණ බෑගය",
  钱包充值_线下_: "පසුම්බිය නැවත ආරෝපණය (නොබැඳි)",
  申请提款: "මුදල් ආපසු ගැනීම සඳහා ඉල්ලුම් කරන්න",
  钱包收支明细: "පසුම්බි ආදායම සහ වියදම් විස්තර",
  批准: "අනුමත කිරීම",
  提现历史记录: "බඳවා ගැනීමේ historical තිහාසික වාර්තාව",
  类型: "වර්ගය",
  信息: "තොරතුරු",
  付款方式: "ගෙවීම් ක්රමය",
  请选择付款方式: "කරුණාකර ගෙවීම් ක්රමය තෝරන්න",
  Bill_Type_RECHARGE_BACK: "පසුබිම් නැවත ආරෝපණය",
  Bill_Type_RECHARGE_ONLINE: "මාර්ගගත නැවත ආරෝපණය",
  Bill_Type_RECHARGE_REGISTER: "ලියාපදිංචි වන්න",
  Bill_Type_RECHARGE_JACKPOT: "නැවත ආරෝපණය කිරීම",
  Bill_Type_RECHARGE_PRESENT: "රීචාජ් ත්යාගය",
  Bill_Type_RECHARGE_FROM_COMMISSION: "කොමිෂන් හුවමාරු හුවමාරුව",
  Bill_Type_RECHARGE_TG_COMMISSION: "ප්රවර්ධන කොමිෂන් සභාව නැවත ආරෝපණය කිරීම",
  Bill_Type_REGISTER_TG_COMMISSION: "ලියාපදිංචි කිරීම සහ ප්රවර්ධන කොමිෂන් සභාව",
  Bill_Type_WITHDRAW: "ඉවත් වන්න",
  Bill_Type_WITHDRAW_REJECT: "ඉවත් වන්න",
  Bill_Type_DEDUCT_HANDLE: "අත්පොත අඩු කිරීම",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "නැවත ආරෝපණය කිරීම",
  Bill_Type_MINING_PROFIT: "පතල් ආදායම්",
  Bill_Type_MINING_PROFIT_COMMISSION: "පතල් නිවාස ප්රවර්ධන කොමිෂන් සභාව",
  Bill_Type_VIP_UPGRADE: "උත්ශ්රේණිගත කිරීම",
  Bill_Type_FINANCE_BUY: "ධනය කළමනාකරණ නිෂ්පාදන මිලදී ගැනීම",
  Bill_Type_FINANCE_CAPITAL_RETURN: "මූල්ය ශේෂය නැවත පැමිණීම",
  Bill_Type_FINANCE_FEE: "මූල්ය හැසිරවීමේ ගාස්තුව",
  Bill_Type_FINANCE_PROFIT: "මූල්ය ආදායම",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "ධනය කළමනාකරණ නිෂ්පාදන සඳහා කොමිස් මිලදී ගැනීම",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "ධනය කළමනාකරණ නිෂ්පාදන ආදායම් කොමිෂන් සභාව",
  Bill_Type_WHEEL_DRAW: "විශාල කරකැවිය හැකි රැෆල්",
  Bill_Type_BUY: "භාණ්ඩ මිලදී ගන්න",
  Bill_Type_PAY_SHOP: "බෙදා හැරීමේ ගාස්තුව ගෙවන්න",
  Bill_Type_BUY_COMMISSION: "භාණ්ඩ කොමිෂන් සභාව මිලදී ගන්න",
  Bill_Type_DEPOSIT: "තැන්පතුවක් ගෙවන්න",
  Bill_Type_STORE_BUY: "භාණ්ඩ මිලදී ගන්න",
  Bill_Type_STORE_BUY_REFUND: "මුදල් ආපසු ගෙවන්න",
  Bill_Type: "ණය වෙනස් කිරීමේ වර්ගය",
  Before_Money: "පෙර මුදල",
  Deal_Money: "ගිණුම් වෙනස් කිරීමේ මුදල",
  After_Money: "පසුකාලීන මුදල",
  Bill_Time: "ගිණුම් වෙනස් කිරීමේ වේලාව",
  No_More_Data: "තවත් දත්ත නොමැත",
  Apply_Money: "යෙදුම් මුදල",
  Apply_Time: "යෙදුම් කාලය",
  Withdraw_Info: "හැසිරවීමේ ගාස්තු: {ගාස්තු}, ගිණුමට: {මුදල්}",
  提款订单状态_CHECKING: "සමාලෝචනය කිරීමට",
  提款订单状态_TRANSFERRING: "මාරු කිරීම",
  提款订单状态_PASS: "තහවුරු කරන්න",
  提款订单状态_REJECT: "ප්රතික්ෂේප විය",
  暂无可用充值方式: "ප්රයෝජනවත් නැවත ආරෝපණ ක්රමයක් නොමැත",
  钱包收款码: "පසුම්බිය එකතු කිරීමේ කේතය",
  钱包地址: "පසුම්බිය ලිපිනය",
  金额限制: "මුදල සීමාව",
  复制: "පිටපත",
  付款凭证: "ගෙවීම් වවුචරය",
  收款银行: "ලැබිය යුතු බැංකුව",
  收款人: "අයකැමි",
  收款账号: "කුවිතාන්සිය ගිණුම",
  付款银行: "ගෙවුම් බැංකුව",
  付款人: "ගෙවන්නා",
  付款账号: "ගෙවීම් ගිණුම",
  请输入付款银行: "කරුණාකර ගෙවීම් බැංකුව ඇතුළත් කරන්න",
  请输入付款人: "කරුණාකර ගෙවන්නා ඇතුළත් කරන්න",
  请输入付款账号: "කරුණාකර ගෙවීම් ගිණුම ඇතුළත් කරන්න",
  请上传付款凭证: "කරුණාකර ගෙවීම් වවුචර උඩුගත කරන්න",
  充值金额: "නැවත ආරෝපණය කරන්න",
  请输入充值金额: "කරුණාකර නැවත ආරෝපණය කිරීමේ මුදල ඇතුළත් කරන්න",
  submitting: "ඉදිරිපත් කළ ...",
  Confirm: "ඉදිරිපත් කරන්න",
  Commit_Success: "සාර්ථක ඉදිරිපත් කිරීම",
  balanceType_BALANCE: "ශේෂය",
  balanceType_COMMISSION: "කොමිෂන් සභාව",
  Balance: "ගිණුම් ශේෂය",
  Wash_Money: "කේතීකරණය",
  请选择银行账户: "කරුණාකර බැංකු ගිණුම තෝරන්න",
  卡号类型: "කාඩ් අංකය",
  提现金额: "මුදල් ආපසු ගැනීමේ මුදල",
  提款金额: "මුදල් ආපසු ගැනීමේ මුදල",
  不能为空: "හිස් විය නොහැක",
  金额不正确: "වැරදි මුදල",
  please_input_withdraw_password: "මුදල් ආපසු ගැනීමේ මුරපදය ඇතුළත් කරන්න",
  withdraw_password_format_error:
    "මුදල් ආපසු ගැනීමේ මුරපදය 4-16-බිට් අක්ෂර විය යුතුය",
  Fee: "හැසිරවීමේ ගාස්තුව",
  实际到账: "ඇත්තටම",
  交易币种: "වෙළඳ මුදල්",
  原始密码: "ප්රාථමික මුරපදය",
  confirm_password_error: "යෙදවුම් දෙකක මුරපදය වැරදිය",
  save_success: "සාර්ථක වන්න",
  please_input: "කරුණාකර ඇතුලත් කරන්න",
  old_password: "පැරණි මුරපදය",
  new_password: "නව මුරපදය",
  please_input_confirm_password: "කරුණාකර මුරපදය නැවත තහවුරු කරන්න",
  没有找到符合条件的商品: "සුදුසුකම් ලත් නිෂ්පාදන සොයාගත නොහැක",
  Search: "සෙවීම",
  全部: "සියල්ල",
  EnumGoodsOrderState_USER_PAY: "බෙදා හැරීමට",
  EnumGoodsOrderState_SHOP_PAY: "බෙදා හැරීම",
  EnumGoodsOrderState_SUCCESS: "අවසන්",
  EnumGoodsOrderState_CANCEL: "අවලංගු කරන්න",
  EnumGoodsOrderState_REFUND_SUCCESS: "මුදල් ආපසු ගෙවීම",
  订单号: "ඇණවුම් අංකය",
  用户名称: "පරිශීලක නාමය",
  收益: "ආදායම",
  支付时间: "ගෙවීමේ කාලය",
  配送时间: "බෙදාහැරීමේ කාලය",
  完成时间: "සම්පූර්ණ කාලය",
  发货: "නැව",
  全选: "සම්පූර්ණ තේරීම",
  物品已添加到愿望清单: "අයිතම පැතුම් ලැයිස්තුවට එකතු කර ඇත",
  物品已添加到比较列表: "සංසන්දනාත්මක ලැයිස්තුවට අයිතම එකතු කර ඇත",
  购买成功提示: "සුභ පැතුම්, සාර්ථකව මිලදී ගන්න",
  订单列表: "ඇණවුම් ලැයිස්තුව",
  商品名: "නිෂ්පාදන නම",
  图片: "පින්තූරය",
  没有品牌: "වෙළඳ නාමයක් නැත",
  基本信息: "මූලික තොරතුරු",
  Account_Name: "නම",
  Bank_Account: "බැංකු ගිණුම",
  Bank_Phone: "සංචිත ජංගම දුරකථන අංකය",
  IFSC: "IFSSC ගිණුම",
  UPI: "උප ගිණුම",
  PIX: "PIX ගිණුම් අංකය",
  CPF: "සීපීඑෆ් ගිණුම",
  GCASH: "GCash ගිණුම",
  POWWI: "Powwi ගිණුම",
  身份证号: "හැඳුනුම් අංකය",
  Edit: "සංශෝධනය කරන්න",
  Delete: "මකන්න",
  Add: "වැඩි කරන්න",
  Forget_Withdraw_Password: "ඉවත් වීමේ මුරපදය සමඟ අමතක කරන්න",
  Bank_Card_Info: "බැංකු කාඩ්පත් තොරතුරු",
  收款人地址: "මුදල් අයකැමි ලිපිනය",
  SWIFT: "ස්විෆ්ට්",
  Bank_Branch: "උප-බිඳම නම",
  分行代码: "ශාඛා කේතය",
  银行地址: "බැංකු ලිපිනය",
  Email: "විද්යුත් තැපෑල",
  银行卡长度必须超过: "බැංකු කාඩ්පතේ දිග {දිග} නොඉක්මවිය යුතුය",
  银行卡格式不正确: "බැංකු කාඩ්පත් ආකෘතිය වැරදිය",
  Do_you_confirm_delete: "ඔබ මකාදැමීම තහවුරු කරනවාද?",
  Please_Login_First: "කරුණාකර පළමුව ලොග් වන්න",
  Bank_Name: "බැංකු නාමය",
  Please_add_bank_first:
    "ඔබ බැංකු කාඩ්පතක් බැඳ නොතිබීම, කරුණාකර එය පළමුව එකතු කරන්න",
  withdrawType: "මුදල් ආපසු ගැනීම",
  withdraw_money_limit:
    "මුදල් ආපසු ගැනීමේ ප්රමාණය 0 හා thange ශේෂය to ට වඩා වැඩි හෝ සමාන විය යුතුය}",
  withdraw_times_limit:
    "ඔබ අද {අද දින {juswithdravem} උපුටා දැක්වීය. {සීමාව} කාලයෙන් පසු, ඔබ හැසිරවීමේ ගාස්තුවෙන්} මුදල් ආපසු ගැනීම}% ක් අය කරනු ඇත. මුදල් ආපසු ගැනීම සඳහා එය අධිෂ් is ාන කරගෙන තිබේද?",
  Copy_Success: "අනුරූකරණය",
  商店首页: "මුල් පිටුව ගබඩා කරන්න",
  所有产品: "සියලුම නිෂ්පාදන",
  新到货产品: "නව -අස්ත",
  所有商家: "සියලුම වෙළෙන්දෝ",
  请上传: "කරුණාකර උඩුගත කරන්න",
  请输入: "කරුණාකර ඇතුලත් කරන්න",
  忘记密码: "මුරපදය අමතක කරන්න",
  记得我: "මාව මතක ද",
  共_件: "මුළු {0} කොටස",
  取消订单: "ඇණවුම අවලංගු කරන්න",
  申请退款: "මුදල් ආපසු ගෙවීම සඳහා අයදුම් කරන්න",
  未知商家: "නොදන්නා වෙළෙන්දා",
  到账: "ගිණුම",
  提款订单状态: "මුදල් ආපසු ගැනීමේ ඇණවුම් තත්වයක්",
  前_名类别: "පළමු කාණ්ඩයේ {0 වර්ගය",
  取消订单原因_不想要了: "තවදුරටත් අවශ්ය නැත",
  取消订单原因_商品错选_多选: "නිෂ්පාදන වැරදි / බහුවිධ තේරීම",
  取消订单原因_商品无货: "පිටතට -goods",
  取消订单原因_地址信息填写错误: "ලිපින තොරතුරු දෝෂය පුරවන්න",
  取消订单原因_商品降价: "වෙළඳ භාණ්ඩ මිල අඩු කිරීම",
  取消订单原因_价格高于其他平台: "මිල අනෙකුත් වේදිකාවලට වඩා වැඩි ය",
  取消订单原因_没用_少用_错用优惠: "කිසිවක් / භාවිතය අඩු / දෝෂ වට්ටම්",
  退款原因_拍错_多拍_不喜欢: "වැරදි / වැඩිපුර වෙඩි තියන්න / එයට කැමති නැත",
  退款原因_商品成分描述不符: "නිෂ්පාදන සංරචක විස්තරය නොගැලපේ",
  退款原因_与商家协商一致退款: "වෙළෙන්දා ආපසු ගෙවීම සමඟ සාකච්ඡා කිරීම",
  退款原因_生产日期_保质期与商品描述不符:
    "නිෂ්පාදන දිනය / රාක්කයේ ආයු කාලය නිෂ්පාදන විස්තරයට නොගැලපේ",
  退款原因_图片_产地_批号_规格等描述不符:
    "රූපය / ආරම්භක ස්ථානය / කණ්ඩායම් අංකය / පිරිවිතර, ආදිය.",
  退款原因_质量问题: "තත්ත්ව ගැටලුව",
  退款原因_商品变质_发霉_有异物: "නිෂ්පාදන නරක් / අච්චුව / විදේශීය ශරීරය",
  退款原因_少件_含缺少配件_: "කුඩා අයිතම (උපාංග නොමැතිකම ඇතුළුව)",
  退款原因_收到商品时有破损_污渍_变形:
    "නිෂ්පාදිතය ලැබෙන විට, හානියක් / පැල්ලම් / විරූපණය ඇත",
  退款原因_假冒品牌: "ව්යාජ",
  退款原因_发票问题: "ඉන්වොයිස් ගැටලුව",
  退款原因_商家发错货: "වෙළෙන්දෝ වැරදි භාණ්ඩ යවයි",
  退款原因_预约不到_商家不给退换: "හමුවීමක් / වෙළඳාමක් ලබා දිය නොහැක",
  退款失败: "අසමත් වීම",
  退款处理中: "මුදල් ආපසු ගෙවීම",
  默认: "පෙරනිමි",
  产品查询: "නිෂ්පාදන විමසුම",
  商店LOGO: "සාප්පු ලාංඡනය",
  推广码: "ප්රවර්ධන කේතය",
  查看所有: "සියල්ල පරීක්ෂා කරන්න",
  确认收货成功: "කුවිතාන්සිය සාර්ථක බව තහවුරු කරන්න",
  物流公司: "ලොජිස්ටික් සමාගම",
  物流单号: "ලොජිස්ටික් ඇණවුම් අංකය",
  发货时间: "බෙදාහැරීමේ කාලය",
  请先选择商品规格: "කරුණාකර පළමුව නිෂ්පාදන පිරිවිතරය තෝරන්න",
  个人信息: "පුද්ගලික තොරතුරු",
  您的用户名: "ඔබේ පරිශීලක නාමය",
  你的名字: "ඔයාගේ නම",
  登录名: "පරිශීලක නාමය",
  你的邮件: "ඔබේ තැපෑල",
  你的密码: "ඔබගේ මුරපදය",
  重复输入密码: "මුරපදය නැවත කරන්න",
  店铺名称: "සාප්පු නාමය",
  证书类型: "වර්ගය",
  身份证: "ID කාඩ්පත",
  护照: "විදේශ ගමන් බලපත්රය",
  驾驶执照: "රියදුරු බලපත්රය",
  社会保障卡: "සමාජ ආරක්ෂණ කාඩ්පත",
  证书正面: "ධනාත්මක සහතිකය",
  证书反面: "සාධනය",
  确认收货: "භාණ්ඩ ලැබීම තහවුරු කරන්න",
  请选择取消订单的原因必选:
    "ඇණවුම අවලංගු කිරීමට කරුණාකර හේතුව තෝරන්න (අවශ්යයි):",
  请选择申请退款的原因必选:
    "කරුණාකර මුදල් ආපසු ගෙවීමක් සඳහා අයදුම් කිරීමට හේතුව තෝරන්න (අවශ්යයි):",
  留言: "පණිවිඩය",
  请输入留言: "කරුණාකර පණිවිඩයක් ඇතුළත් කරන්න",
  没有帐户: "ගිණුමක් නැත",
  钱包充值: "පසුම්බිය නැවත ආරෝපණය කිරීම",
  输入您的文字: "ඔබේ පෙළ ඇතුළත් කරන්න",
  商家登录: "වෙළඳ පිවිසුම",
  有关此产品的任何查询: "මෙම නිෂ්පාදනය පිළිබඳ කිසියම් විමසුමකට",
  产品名称: "නිෂ්පාදන නම",
  你的问题: "ඔබේ ගැටලුව",
  白银店铺: "රිදී සාප්පුව",
  铂金店铺: "ප්ලැටිනම් සාප්පුව",
  钻石店铺: "දියමන්ති සාප්පුව",
  照片: "ඡායාරූපය",
  已退货: "ආපසු",
  邮寄状态: "තැපැල් තත්ත්වය",
  订单摘要: "සාරාංශය ඇණවුම් කරන්න",
  收件地址: "ආදායම් ලිපිනය",
  订购日期: "ඇණවුම් දිනය",
  订单状态: "ඇණවුම් තත්ත්වය",
  总订单金额: "මුළු ඇණවුම් මුදල",
  邮寄方式: "තැපැල් ක්රමය",
  附加信息: "අමතර තොරතුරු",
  订单详细信息: "සවිස්තරාත්මක තොරතුරු",
  交货类型: "බෙදා හැරීමේ වර්ගය",
  进行评论: "අදහස් දැක්වීම",
  已评论: "අදහස් දැක්වීය",
  订单金额: "ඇණවුම් මුදල",
  优惠券: "කූපනය",
  统一运费: "ඒකාබද්ධ භාණ්ඩ ප්රවාහනය",
  送货地址: "බෙදාහැරීමේ ලිපිනය",
  评分: "ස්කෝර්",
  你的意见: "ඔබේ මතය",
  匿名: "නිර්නාමික",
  现金: "මුදල්",
  详情: "විස්තර",
  收货地址: "කුවිතාන්සි ලිපිනය",
  暂时没有对话: "කාලය සඳහා සංවාදයක් නොමැත",
  你: "ඔබ",
  输入您的回复: "ඔබේ පිළිතුර ඇතුළත් කරන්න",
  删除成功: "මකන්න",
  品牌: "වෙළඳ නාමය",
  已缴纳的保证金: "ආන්තිකය ගෙවා ඇත",
  黄金店铺: "ගෝල්ඩන් සාප්පුව",
  没有更多数据: "තවත් දත්ත නොමැත",
  站内信: "-සිට් ලිපියේ",
  系统通知: "පද්ධති දැනුම්දීම",
  邮箱: "තැපෑල",
  手机号: "දුරකථන අංකය",
  你的手机号: "ඔබගේ ජංගම දුරකථන අංකය",
  营业执照: "ව්යාපාර බලපත්රය",
  你的邮箱: "ඔබගේ තැපැල් පෙට්ටිය",
  搜索结果: "සෙවුම් ප්රති .ල",
  系统公告: "පද්ධති නිවේදනය",
  客服: "පාරිභෝගික සේවාව",
  消息已撤回: "ප්රවෘත්ති ඉවත් කර ඇත",
  物流详情: "ලොජිස්ටික් විස්තර",
  充值: "ඉහළට ඉහළට",
  提现: "ඉවත් වන්න",
  信用分: "ණය",
  余额: "ශේෂය",
  佣金: "කොමිෂන් සභාව",
  继续购物: "සාප්පු යාම දිගටම කරගෙන යන්න",
  订单结算: "ඇණවුම් බේරුම්කරණය",
  加入对比: "සංසන්දනය එක් කරන්න",
  佣金余额: "කොමිෂන් ශේෂය",
  刷新: "නැවුම් කරන්න",
  刷新成功: "නැවුම් කරන්න",
  官网: "නිල වෙබ් අඩවිය",
  税号: "බදු අංකය",
  订单: "ඇණවුම",
  合计: "එකතුව",
  系统安全: "පද්ධති ආරක්ෂාව",
  Recharge_Money_Limit:
    "නැවත ආරෝපණය කිරීමේ මුදල {min} සහ {මැක්ස්} අතර විය යුතුය",
  限时优惠: "සීමිත කාලයක්",
  高价回收: "ඉහළ ප්රතිචක්රීකරණය",
  姓名: "නම",
  商品订单号: "වෙළඳ භාණ්ඩ ඇණවුම් අංකය",
  商品在线回收: "වෙළඳ භාණ්ඩ ඔන්ලයින් ප්රතිචක්රීකරණය",
  提交: "ඉදිරිපත් කරන්න",
  回收记录: "ප්රතිසාධන වාර්තාව",
  回收状态: "ප්රතිසාධන තත්ත්වය",
  回收价格: "ප්රතිචක්රීකරණ මිල",
  纳税码: "බදු කේතය",
  买家登录: "ඇතුල් වන්න",
  买家注册: "ලියාපදිංචි වන්න",
  language: "චීන",
  助力提示:
    "වෙළෙන්දන්ට උපකාර කිරීමෙන් වේදිකාව ඔවුන්ගේ වෙළඳසැල් වලට නිරාවරණය වීම වැඩි කළ හැකි අතර, සමුච්චිත දින ගණන වැඩි වන තරමට නිරාවරණය වේ.",
  已累计助力: "සමුච්චිත ලෙස සහාය වීම",
  今日已助力: "අද උදව් කර ඇත",
  立即助力: "වහාම උදව් කරන්න",
  商家助力: "මර්චන්ට් උදව්",
  证件号码: "හැඳුනුම් අංකය",
  证书号码: "සහතික අංකය"
};
